import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { appVariables } from './helpers/appVariables';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
// import countrycode from './Pages/Home/countrycode.json';
import { history } from './helpers/history';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { commonClass } from './helpers/commonClass';

class EnterForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: ['', '', '', '', '', ''],
            newPwd: "",
            ConfirmPwd: "",
            shownewpwd: false,
            showconfrimpwd: false,
            myRTime: 0,
            timeFinished: false,
            myRefNo: 0,
            ShowErrorMsg: ""
        }
        this.handleChange = this.handleChange.bind()
    }
    handleChange = (e) => {
        try {
            this.setState({ ShowErrorMsg: "" })
            this.setState({ [e.target.name]: e.target.value });
        }
        catch (ex) { }
    }
    static getDerivedStateFromProps(props, state) {
        return { otp: props.otp };
    };

    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setState({ ShowErrorMsg: errorstring });
        }
        else {
            this.props.alertError(errorstring);
        }
    }

    handleInputChange = (value, e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState(prevState => ({ list: prevState.list.map((obj, inx) => (inx === value ? e.target.value : obj)) }));
            if (((this.state.list.length - 1) > value) || e.target.value == "") {
                let Check = `input[name='${e.target.value !== "" ? (parseInt(value) + 1) : ((value !== 0) ? parseInt(value) - 1 : parseInt(value))}']`;
                document.querySelector(`input[name='${e.target.value !== "" ? (parseInt(value) + 1) : ((value !== 0) ? parseInt(value) - 1 : parseInt(value))}']`).focus();
                // document.querySelector(`input[name=2`).focus()
            }
        }
    }

    // btnForgetPwd = (e) => {
    //     e.preventDefault();
    //     if (this.state.newPwd && this.state.newPwd.trim() != "" && this.state.ConfirmPwd && this.state.ConfirmPwd.trim() != "") {
    //         let _otp = this.state.otp.otp.split(':')[1];
    //         // let regEx = /^(?=.*?[0-9])(?=.*?[^0-9A-Za-z]).{8,15}$/;
    //         let regEx = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,20}$/
    //         if (regEx.test(this.state.newPwd)) {
    //             if (this.state.newPwd == this.state.ConfirmPwd) {
    //                 this.state.newPwd = this.state.newPwd.replace(/'/g, "''");
    //                 this.props.changepassword(this.props.otp.mobileNo, _otp, this.state.newPwd, appVariables.PASSWORD_FLAG.ForgetPasswordFlag, this.props.i18n.language, this.props.user.loginKey, this.state.otp.Ccode)
    //                 this.setState({ newPwd: '', ConfirmPwd: '' })
    //             }
    //             else {
    //                 this.showMsg('lblPwdMismatch');
    //             }
    //         }
    //         else { this.showMsg('lblReqPasswordPolicy'); }
    //     }
    //     else {
    //         this.showMsg('lblPleaseFillDet');
    //     }
    // }

    btnForgetPwd = (e) => {
        e.preventDefault();

        const { newPwd, ConfirmPwd, otp } = this.state;
        const { mobileNo, Ccode } = otp || {};
        const { i18n, user } = this.props;
        let validationfalg = true
        // Check if both password fields are filled
        if (!newPwd || newPwd.trim() === "" || !ConfirmPwd || ConfirmPwd.trim() === "") {
            this.showMsg('lblPleaseFillDet',1);
            validationfalg = false
        }
        // Password policy check (at least 1 uppercase, 1 digit, 1 special char, 8–20 chars)
        const regEx = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,20}$/;
        if (!regEx.test(newPwd) && validationfalg) {
            this.showMsg('lblReqPasswordPolicy',1);
            validationfalg = false
        }
        // Confirm password match
        if (newPwd !== ConfirmPwd) {
            this.showMsg('lblPwdMismatch',1);
            validationfalg = false
        }
        if (validationfalg) {
            // Extract OTP
            let extractedOtp = "";
            try {
                extractedOtp = otp.otp.split(':')[1];
            } catch {
                this.showMsg('lblInvalidOtp',1);
                return;
            }
            // Sanitize and submit
            const sanitizedPwd = newPwd.replace(/'/g, "''");
            this.props.changepassword(
                mobileNo,
                extractedOtp,
                sanitizedPwd,
                appVariables.PASSWORD_FLAG.ForgetPasswordFlag,
                i18n.language,
                user.loginKey,
                Ccode
            );
            // Clear form
            this.setState({ newPwd: '', ConfirmPwd: '' });
        }

    };


    ResendOtp = () => {
        if (this.props.otp.mobileNo && this.props.otp.mobileNo != "") {
            if (this.state.timeFinished == false) {
                // this.props.alertError(this.props.t("Try after OTP expired"));                
                return;
            }
            if (this.props.otp.flog == 3) {
                this.props.Otpgen(this.props.otp.mobileNo, appVariables.OTP.ForgetPassword, this.props.i18n.language, this.props.user.loginKey, this.state.otp.Ccode)
            }
        }
    }

    componentDidMount(prevState, prevProps) {
        setTimeout(() => {
            if (window.LoginOverlay) {
                window.LoginOverlay()
            }
        }, 500);
    }
    componentDidUpdate(previousProps, previousState) {
        if (this.props.otp && this.props.otp.ExpSec && this.props.otp.ExpSec > 0) {
            if (this.state.myRefNo != this.props.otp.RefNo) {//to check new otp after click resend btn
                this.state.myRefNo = this.props.otp.RefNo;
                this.state.myRTime = 0;
                this.state.timeFinished = false;
            }
            if (this.state.timeFinished == true) //check the time completed
            {
                return;
            }
            let tot = 0
            if (this.state.myRTime > 0) {
                tot = this.state.myRTime;
            }
            else {
                tot = this.props.serverTime + (this.props.otp.ExpSec * 1000);
                this.state.myRTime = tot;
            }
            let _rtime = tot - this.props.serverTime;
            let second = 1000
            let minute = second * 60
            let hour = minute * 60
            let day = hour * 24
            let _mintime = Math.floor(_rtime % day % hour / minute);
            let _sectime = Math.floor(_rtime % day % hour % minute / second);
            this.state.Rtime = _mintime + " : " + _sectime;
            if (_mintime <= 0 && _sectime <= 0) {
                this.state.Rtime = "";
                this.state.timeFinished = true;
            }
        }
    }
    render() {
        const { t } = this.props;
        let ShowErrorMsg = this.state.ShowErrorMsg.length > 0
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket - Login</title>
                    <meta name="description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Login" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    <meta property="og:description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <div class="signInBox" style={{ display: "block" }}>
                    <div class="signInBoxWrap">
                        <div class="signBoxLft">
                            <img src="./assets/img/sign-lft.png" />
                        </div>
                        <div class="signBoxRht">
                            <div class="userContent">
                                <a class="lightBoxClose" ><img src="./assets/img/icons/pop_close.png" /></a>
                                <h1>{t('lblResetPwd')}</h1>
                                <p>{t('lblresetpassquotes')}</p>
                                <form class="register-form paddTop-20" onSubmit={this.btnForgetPwd}>
                                    <div class="formCont">
                                        <label>{t('lblNewPwd')} <sup>*</sup></label>
                                        <input className={`${ShowErrorMsg ? "errorBorder" : ""}`} type={this.state.shownewpwd ? "text" : "password"} placeholder="********" id="txtNewPwd" name="newPwd" value={this.state.newPwd} onChange={(e) => this.handleChange(e)} maxLength={20} />
                                        {ShowErrorMsg && <div class="errorTxt">{this.state.ShowErrorMsg}</div>}
                                        {this.state.shownewpwd ? <small id="eyeIcon" class="eyeIcon eyeOpen" onClick={() => this.setState({ shownewpwd: false })}></small>
                                            : <small id="eyeIcon" class="eyeIcon eyeClose" onClick={() => this.setState({ shownewpwd: true })} ></small>}
                                    </div>
                                    <div class="formCont margin-0">
                                        <label>{t('lblConfirmpwd')} <sup>*</sup></label>
                                        <input className={`${ShowErrorMsg ? "errorBorder" : ""}`} type={this.state.showconfrimpwd ? "text" : "password"} placeholder="********" id="txtConfirmPwd" name="ConfirmPwd" value={this.state.ConfirmPwd} onChange={(e) => this.handleChange(e)} maxLength={20} />
                                        {ShowErrorMsg && <div class="errorTxt">{this.state.ShowErrorMsg}</div>}
                                        {this.state.showconfrimpwd ? <small id="eyeIcon" class="eyeIcon eyeOpen" onClick={() => this.setState({ showconfrimpwd: false })}></small>
                                            : <small id="eyeIcon" class="eyeIcon eyeClose" onClick={() => this.setState({ showconfrimpwd: true })} ></small>}
                                    </div>
                                    <div class="formCont">
                                        <button class="">{t('lblResetPwd')}</button>
                                    </div>
                                </form>
                                <span class="agree"><a onClick={() => { this.props.getflag(0) }} target="_blank">{t('lblback')} {t('lblLogin')}</a></span>
                                 <div class="formContError1 margin-top-30">
                            <div class="passInfo">{t('lblpassrule')}</div>
                            <ul>
                                <li>{t('lblpassruleone')}</li>
                                <li>{t('lblpassruletwo')}</li>
                                <li>{t('lblpassrulethree')}</li>
                                <li>{t('lblpassrulefour')}</li>
                            </ul>
                        </div>
                            </div>
                        </div>
                    </div>
                </div >
                <div class="overlayLogin" style={{ display: "block" }}></div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, otp, appvariables } = state.loginReducer;
    return { user, otp, appvariables };
}
const mapActionToProps = {
    login: loginActions.login,
    setPage: loginActions.setPage,
    Otpgen: loginActions.lfnotpgen,
    alertError: alertActions.error,
    logout: loginActions.logout,
    changepassword: loginActions.changepassword
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(EnterForgotPassword))